import {isFunction} from 'lodash'
import { Message } from 'element-ui'
export class CopyGridCells {
  constructor (param) {
    const {
      selection
    } = param || {}
    this.params = param
    this.selection = selection
    this.controlPressed = false
    this.controlKey = ''
    this.isFocusTargetNode = false

    this.handlerKeyDownEvent = this.handlerKeyDownEvent.bind(this)
    this.handlerKeyUpEvent = this.handlerKeyUpEvent.bind(this)
    this.handleClickEvent = this.handleClickEvent.bind(this)
    this.handleCopyEvent = this.handleCopyEvent.bind(this)
    this.handleMouseenterEvent = this.handleMouseenterEvent.bind(this)
    this.handleMouseleaveEvent = this.handleMouseleaveEvent.bind(this)
    this.handlerMouseClickInKeyDownEvent = this.handlerMouseClickInKeyDownEvent.bind(this)
    this.init()
  }
  init () {
    // 添加键盘按下事件监听器
    document.addEventListener('keydown', this.handlerKeyDownEvent)

    // 添加键盘松开事件监听器
    document.addEventListener('keyup', this.handlerKeyUpEvent)
    // 监听鼠标按下事件
    this.params.node.addEventListener('mousedown', this.handleClickEvent, {
      passive: true // 一个布尔值，设置为 true 时，表示 listener 永远不会调用 preventDefault()。如果 listener 仍然调用了这个函数，客户端将会忽略它并抛出一个控制台警告。查看使用 passive 改善滚屏性能以了解更多。
    })
    this.params.node.addEventListener('mousemove', this.handleMouseenterEvent)
    this.params.node.addEventListener('mouseleave', this.handleMouseleaveEvent)
  }
  handleMouseenterEvent (e) {
    this.isFocusTargetNode = true
  }
  handleMouseleaveEvent (e) {
    this.isFocusTargetNode = false
  }
  clearEvent () {
    document.removeEventListener('keydown', this.handlerKeyDownEvent)
    document.removeEventListener('keyup', this.handlerKeyUpEvent)
    this.params.node.removeEventListener('mousedown', this.handleClickEvent, {
      passive: true
    })
    this.params.node.removeEventListener('mousemove', this.handleMouseenterEvent)
    this.params.node.removeEventListener('mouseleave', this.handleMouseenterEvent)
  }
  handleClickEvent (event) {
    const key = this.controlKey
    if (this.controlPressed && event[key] && event.button === 0) {
      this.handlerMouseClickInKeyDownEvent(event)
    } else {
      this.controlPressed = false
      this.params.clear()
      this.selection.clear()
    }
  }
  handlerMouseClickInKeyDownEvent (event) {
    const target = event.target
    if (!target) {
      return
    }
    const { handleMouseDownEventCb } = this.params
    isFunction(handleMouseDownEventCb) && handleMouseDownEventCb(event, this)
  }
  addSelection (obj) {
    this.selection.add(obj)
  }
  hasSelection (obj) {
    return this.selection.has(obj)
  }
  deleteSelection (obj) {
    this.selection.delete(obj)
  }
  isGridCross () {
    return this.selection.isGridCross()
  }
  handleCopyEvent (event) {
    // 不允许复制跨行或者跨列的选中值。并提示
    const copiedText = this.selection.getSelected()
    // 确保是controlPressed键和在元素内
    if (this.controlPressed && this.isFocusTargetNode) {
      let beforeCopyed = null
      const { beforeCopy } = this.params
      if (isFunction(beforeCopy)) {
        beforeCopyed = beforeCopy(this)
      }
      if (!beforeCopyed) {
        return
      }
      if (!copiedText) {
        return
      }
      // 复制的时候需要阻止默认行为，这样才能替换原有的内容
      event.preventDefault()
      // 将已选的内容添加到剪贴板
      event.clipboardData.setData('text', copiedText)
      Message({
        type: 'success',
        message: '复制成功'
      })
      this.controlPressed = false
      this.selection && this.selection.clear()
      this.params && this.params.clear()
      document.removeEventListener('copy', this.handleCopyEvent)
    }
  }
  handlerKeyDownEvent (event) {
    // console.log(event, '--------keydown')
    if (['Meta', 'Control'].includes(event.key)) {
      this.controlPressed = true
      this.controlKey = event.key === 'Meta' ? 'metaKey' : 'ctrlKey'
      document.addEventListener('copy', this.handleCopyEvent)
    }
  }
  handlerKeyUpEvent (event) {
    this.controlPressed = false
  }
}



// WEBPACK FOOTER //
// ./src/public/plugins/copy-cells/index.js